<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? `Editing ${item.name}` : 'Create New Equipment'"
                             subtitle="Provide the main details of the Equipment in this section."
                             class="py-8 border-b">
                <ui-input-file preview :current="editMode ? item.imageUrl : null" label="Image" name="image"
                               :error="form.errors.get('image')" v-model="form.image"></ui-input-file>
                <ui-input label="Reference" name="reference" :error="form.errors.get('reference')"
                          v-model="form.reference" class="xl:col-span-6"></ui-input>
                <ui-input label="Name" name="name" :error="form.errors.get('name')" v-model="form.name"
                          class="xl:col-span-6"></ui-input>
                <ui-input label="Sku" name="sku" :error="form.errors.get('sku')" v-model="form.sku"
                          class="xl:col-span-6"></ui-input>
                <ui-input label="Weight" name="weight" :error="form.errors.get('weight')" v-model="form.weight"
                          class="xl:col-span-6"></ui-input>
                <ui-textarea autoresize label="Description" name="description" :error="form.errors.get('description')"
                             v-model="form.description"></ui-textarea>
                <ui-select-searchable
                    label="Supplier"
                    placeholder="Associate Item With A Supplier..."
                    v-model="form.supplier"
                    :search="searchCompanies"
                    no-search="Start typing to find companies..."
                ></ui-select-searchable>
            </ui-form-section>
        </ui-container>

        <ui-container>
            <ui-form-section title="Costings" class="py-8 border-b">
                <ui-date-picker label="Purchase Date" name="purchase_date" :error="form.errors.get('purchaseDate')"
                                v-model="form.purchaseDate" placeholder="When was this purchased..."></ui-date-picker>
                <ui-input label="Purchase Price" name="purchase_price" :error="form.errors.get('purchasePrice')"
                          v-model="form.purchasePrice" class="xl:col-span-6"></ui-input>
            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import {Company, Equipment} from '@models'

export default {
    props: {
        equipment: Array,
        item: Object,
        edit: Function,
        addItem: Function,
    },
    data() {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {reference:this.nextReference}

        return {
            nextReference: '',
            form: new Form(initialData, async (form) => {
                try {
                    let data = form.export()
                    if (data.supplier && data.supplier.label) {
                        data.supplier = data.supplier.label
                    }
                    if (this.editMode) {
                        await this.item.update(data)
                        this.edit(false)
                    } else {
                        const equipment = await Equipment.create(data)
                        this.addItem(equipment, 0)

                        form.reset()
                    }
                } catch (error) {
                    if (error.message === 'Invalid Currency') {
                        this.form.errors.errors.purchasePrice = error.message
                    } else {
                        this.form.errors.errors.reference = error.message
                    }
                }
            }),
        }
    },
    methods: {
        async searchCompanies(query) {
            return (await Company.search(query)).map(x => x.toDropdown())
        },
        getNextReference()
        {
            return Math.max(...this.equipment.map((i) => parseInt(0+i.reference))) +1;
        }
    },
    mounted() {
        if (this.equipment) {
            this.nextReference = this.getNextReference()
            this.form.reference = this.nextReference
        }
    },
    computed: {
        editMode() {
            return !!this.item
        },
    },
}
</script>
